import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  const certificatesModal = document.getElementById('certificates-modal');
  const certificatesModalClose = document.getElementById(
    'certificates-modal-close',
  );
  const certificatesModalImage = document.getElementById(
    'certificates-modal-image',
  );
  const certificatesModalPrev = document.getElementById(
    'certificates-modal-prev',
  );
  const certificatesModalNext = document.getElementById(
    'certificates-modal-next',
  );

  // Extract certificate info from DOM tabs
  const tabs = Array.from(
    document.querySelectorAll('#certificates-tabs .certificates__tab'),
  );
  const certificates = tabs.map((tab, index) => {
    return {
      index,
      title: tab.querySelector('span')?.textContent.trim() || '',
      url: tab.getAttribute('data-certificate') || '',
    };
  });

  // Initialize tabs system (only switches content and background, does not open modal automatically)
  initTabSystem({
    tabsContainerSelector: '#certificates-tabs',
    panelsContainerSelector: '#certificates-content',
    tabSelector: '.certificates__tab',
    panelSelector: '.certificates__panel',
    bgImageSelector: '#certificates-bg-image',
    bgContainerSelector: '#certificates-bg',
  });

  let currentIndex = 0;
  let lastFocusedElement = null;

  // Open modal on "Zobacz certyfikat" button click
  const openButtons = document.querySelectorAll('.certificates__btn-open');
  openButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      const index = parseInt(this.getAttribute('data-index'), 10);
      if (!isNaN(index)) {
        lastFocusedElement = document.activeElement;
        openModal(index);
      }
    });
  });

  const openModal = (index) => {
    if (!certificatesModal || !certificatesModalImage) return;

    // Hide navigation arrows if there is 1 or fewer certificates
    if (certificates.length <= 1) {
      if (certificatesModalPrev) certificatesModalPrev.style.display = 'none';
      if (certificatesModalNext) certificatesModalNext.style.display = 'none';
    } else {
      if (certificatesModalPrev) certificatesModalPrev.style.display = 'flex';
      if (certificatesModalNext) certificatesModalNext.style.display = 'flex';
    }

    currentIndex = index;
    const cert = certificates[currentIndex];
    if (cert) {
      certificatesModalImage.src = cert.url;
      certificatesModalImage.setAttribute('alt', cert.title);
      certificatesModal.classList.add('is-open');
      certificatesModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        if (certificatesModalClose) {
          certificatesModalClose.focus();
        }
      }, 100);
    }
  };

  const closeModal = function () {
    if (!certificatesModal) return;
    certificatesModal.classList.remove('is-open');
    certificatesModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (certificatesModalImage) {
      certificatesModalImage.src = '';
      certificatesModalImage.setAttribute('alt', '');
    }
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  };

  const updateModalContent = (index) => {
    if (index < 0 || index >= certificates.length) return;
    currentIndex = index;

    const cert = certificates[currentIndex];
    if (certificatesModalImage && cert) {
      // Smooth fade transition
      certificatesModalImage.style.opacity = '0';

      setTimeout(() => {
        certificatesModalImage.src = cert.url;
        certificatesModalImage.setAttribute('alt', cert.title);
        certificatesModalImage.style.opacity = '1';

        // Synchronize background tabs
        const targetTab = tabs[currentIndex];
        if (targetTab) {
          targetTab.click();
        }
      }, 150);
    }
  };

  // Modal navigation & closing listeners
  if (certificatesModal) {
    if (certificatesModalClose) {
      certificatesModalClose.addEventListener('click', closeModal);
    }

    if (certificatesModalPrev) {
      certificatesModalPrev.addEventListener('click', function (e) {
        e.stopPropagation();
        updateModalContent(
          (currentIndex - 1 + certificates.length) % certificates.length,
        );
      });
    }

    if (certificatesModalNext) {
      certificatesModalNext.addEventListener('click', function (e) {
        e.stopPropagation();
        updateModalContent((currentIndex + 1) % certificates.length);
      });
    }

    // Close on overlay click
    certificatesModal.addEventListener('click', function (e) {
      if (
        e.target === certificatesModal ||
        e.target.classList.contains('modal__container')
      ) {
        closeModal();
      }
    });

    // Keyboard support: Escape to close, arrows to navigate
    document.addEventListener('keydown', function (e) {
      if (certificatesModal.classList.contains('is-open')) {
        if (e.key === 'Escape') {
          closeModal();
        } else if (e.key === 'ArrowRight') {
          updateModalContent((currentIndex + 1) % certificates.length);
        } else if (e.key === 'ArrowLeft') {
          updateModalContent(
            (currentIndex - 1 + certificates.length) % certificates.length,
          );
        }
      }
    });
  }
});
